(function () {
    angular.module('PWAPoCApp').factory('baseLayerFactory', baseLayerFactory);

    baseLayerFactory.$inject = [
        '$q',
        'esriLoader'
    ];

    function baseLayerFactory(
        $q,
        esriLoader
    ) {
        var readyDeferred = null;

        var baseLayerFactory = {
            createLayerOnAdd: true,

            ready: function () {
                if (readyDeferred === null) {
                    readyDeferred = $q.defer();
                }

                return readyDeferred.promise;
            }
        };

        esriLoader.require([
            'esri/layers/TileLayer'
        ], function (TileLayer) {
            if (readyDeferred === null) {
                readyDeferred = $q.defer();
            }

            baseLayerFactory.createLayer = function () {
                var layer = new TileLayer({
                    url: 'https://services.geodataonline.no/arcgis/rest/services/Geocache_UTM33_WGS84/GeocacheBasis/MapServer'
                });
                layer.name = 'BaseMapLayer';
                layer.zIndex = 1;

                //Define additional functions
                layer.toggleVisibility = function () {
                    layer.visible = !layer.visible;
                };

                return layer;
            };

            readyDeferred.resolve(baseLayerFactory);
        });

        return baseLayerFactory;
    }
})();
